module.exports = __webpack_public_path__ + "static/media/paper_hero_tablet.a2c6872a.jpg";